// extracted by mini-css-extract-plugin
export default {"shimmer":"LoadingShimmer_shimmer__ppt+H"};